const permissions = {
	admin: [
		'home',
		'inbound',
		'production',
		'outbound',
		'finance',
		'customer',
		'user',
		'role',
		'permission',
		'otherSettings',
		'medium',
		'salesPerson',
		'goodsType',
		'certificateVolume',
		'inspection',
		'develop',
		'develop:view',
		'develop:add',
		'develop:delete',
		'develop:edit',
		'gas',
		'dilution',
		'gas:view',
		'gas:edit',
		'gas:delete',
		'gas:add',
		'dilution:view',
		'dilution:edit',
		'dilution:delete',
		'dilution:add',
		'print',
		'order',
		'addproduction',
		'order:view',
		'inspection:view',
		'inspection:add',
		'inspection:edit',
		'inspection:delete',
		'inspection:inspection',
		'print:view',
		'print:print',
		'inbound:add',
		'inbound:edit',
		'inbound:delete',
		'inbound:view',
		'production:add',
		'production:edit',
		'production:delete',
		'production:view',
		'outbound:add',
		'outbound:edit',
		'outbound:delete',
		'outbound:view',
		'order_outbound:add',
		'order_outbound:edit',
		'order_outbound:delete',
		'order_outbound:view',
		'order_outbound:print',
		'order_outbound:productadd',
		'cylinderStatistics',
		'customer:add',
		'customer:edit',
		'customer:delete',
		'customer:view',
		'user:add',
		'user:edit',
		'user:delete',
		'user:view',
		'user:resetPassword',
		'role:add',
		'role:edit',
		'role:delete',
		'role:view',
		'role:permission',
		'permission:add',
		'permission:edit',
		'permission:delete',
		'permission:view',
		'otherSettings:add',
		'otherSettings:edit',
		'otherSettings:delete',
		'otherSettings:view',
		'medium:add',
		'medium:edit',
		'medium:delete',
		'medium:view',
		'salesPerson:add',
		'salesPerson:edit',
		'salesPerson:delete',
		'salesPerson:view',
		'goodsType:add',
		'goodsType:edit',
		'goodsType:delete',
		'goodsType:view',
		'certificateVolume:add',
		'certificateVolume:edit',
		'certificateVolume:delete',
		'certificateVolume:view',
		'enterprise',
		'enterprise:add',
		'enterprise:view',
		'enterprise:edit',
		'enterprise:delete',
		'enterprise:status',
		'enterprise:bindUser',
		'unit',
		'unit:add',
		'unit:view',
		'unit:edit',
		'unit:delete',
		'unit:status',
		'scanConfig',
		'scanConfig:add',
		'scanConfig:view',
		'scanConfig:edit',
		'scanConfig:delete',
		'cylinder',
		'cylinder:add',
		'cylinder:view',
		'cylinder:edit',
		'cylinder:delete',
		'department',
		'department:add',
		'department:view',
		'department:edit',
		'department:delete',
		'department:status',
		'volume',
		'volume:add',
		'volume:view',
		'volume:edit',
		'volume:delete',
		'volume:status',
		'certificate',
		'certificate:add',
		'certificate:view',
		'certificate:edit',
		'certificate:delete',
		'certificate:status',
		'contract',
			'contract:add',
			'contract:view',
			'contract:edit',
			'contract:delete',
			'contractSettings',
			'contractList'
		],
	user: [
		'home',
		'inbound',
		'production',
		'outbound',
		'customer',
		'otherSettings',
		'medium',
		'salesPerson',
		'goodsType',
		'certificateVolume',
		'scanConfig',
		'scanConfig:view',
		'cylinder',
		'cylinder:view',
		'cylinderStatistics',
		'inspection',
		'print',
		'gas',
		'dilution',
		'dilution:view',
		'dilution:edit',
		'dilution:delete',
		'dilution:add',
		'gas:view',
		'gas:edit',
		'gas:delete',
		'gas:add',
		'order',
		'order:view',
		'develop',
		'develop:view',
		'develop:add',
		'develop:delete',
		'develop:edit',
		'inspection:view',
		'inspection:add',
		'inspection:edit',
		'inspection:delete',
		'inspection:inspection',
		'order_outbound:add',
		'order_outbound:edit',
		'order_outbound:delete',
		'order_outbound:view',
		'order_outbound:print',
		'order_outbound:productadd',
		'addproduction',
		'print:view',
		'print:print',
		'inbound:view',
		'production:view',
		'outbound:view',
		'customer:view',
		'otherSettings:view',
		'medium:view',
		'salesPerson:view',
		'goodsType:view',
		'certificateVolume:view',
		'volume',
		'volume:view',
		'certificate',
		'certificate:view'
	]
}

export function checkPermission(permission) {
	const currentRole = localStorage.getItem('role') || 'user'
	const rolePermissions = permissions[currentRole] || []
	return rolePermissions.includes(permission)
}

export function checkPermissions(permissionList) {
	return permissionList.some(permission => checkPermission(permission))
}

export function getPermissions() {
	const currentRole = localStorage.getItem('role') || 'user'
	return permissions[currentRole] || []
}

export function setRole(role) {
	localStorage.setItem('role', role)
}

export function getRole() {
	return localStorage.getItem('role') || 'user'
}

export function clearRole() {
	localStorage.removeItem('role')
}